var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"linked-image-button"},[_c('a',{attrs:{"href":_vm.link,"target":"_blank"}},[_c('img',{attrs:{"src":_vm.imageUrl,"alt":_vm.text}}),_vm._v(" "),(_vm.text)?_c('p',[_vm._v(_vm._s(_vm.text))]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }